import { Cart, OrderEntry } from '@vsf-enterprise/sap-commerce-webservices-sdk';
import { GetMaxProductQuantityProps } from '../../../types';

export const getMaxProductQuantity = (
  props: GetMaxProductQuantityProps,
  cart: Cart | null
): number => {
  const { product } = props;

  const stockLevelStatus = product.stock.stockLevelStatus;
  if (stockLevelStatus === 'outOfStock') return 0;

  const productStockLevel = product.stock.stockLevel;
  if (!productStockLevel && stockLevelStatus === 'inStock') return Infinity;

  if (!cart) return productStockLevel;

  const cartEntry = cart.entries.find((entry: OrderEntry) => entry.product.code === product.code);
  if (!cartEntry) return productStockLevel;

  return productStockLevel - cartEntry.quantity;
};
